<script lang="ts">
  import { onMount } from "svelte";

  let bgColor = "";
  onMount(() => {
    const scrollHandler = () => {
      bgColor = window.scrollY > 50 ? "scrolled" : "";
    };
    scrollHandler();
    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  });
</script>

<header
  class={`sticky top-0 z-10 w-full before:absolute before:h-full before:w-full before:backdrop-blur-sm before:transition-colors before:duration-500 ${bgColor} before:-z-1`}
>
  <slot />
</header>

<style lang="postcss">
  .scrolled::before {
    background-color: rgb(from var(--semantic-background-recessed) r g b / 80%);
  }
</style>
